export const AddPhotoIcon = () => {
  return (
    <svg
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 35.5V5.5H23.3333V8.83333H8.33333V32.1667H31.6667V17.1667H35V35.5H5ZM28.3333 15.5V12.1667H25V8.83333H28.3333V5.5H31.6667V8.83333H35V12.1667H31.6667V15.5H28.3333ZM10 28.8333H30L23.75 20.5L18.75 27.1667L15 22.1667L10 28.8333ZM8.33333 18.8333V32.1667V8.83333V18.8333Z"
        fill="#7F7F7F"
      />
    </svg>
  );
};
